import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import BlogCard from '../../components/BlogCard';

const styles = css`
  background-color: #000000;
  padding: 40px 20px 80px;
  @media (max-width: 359.98px) {
    padding-left: 8px;
    padding-right: 8px;
  }
  @media (min-width: 768px) {
    padding: 48px 30px 120px;
  }
  @media (min-width: 850px) {
    padding-left: 40px;
    padding-right: 40px;
  }
  @media (min-width: 992px) {
    padding: 69px 60px 152px;
  }
  @media (min-width: 1200px) {
    padding-left: 90px;
    padding-right: 90px;
  }
  .Blogposts_cardsWrapper {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-left: -8px;
      margin-right: -8px;
    }
    @media (min-width: 992px) {
      margin-left: -15px;
      margin-right: -15px;
    }
  }
  .Blogposts_card {
    width: 100%;
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0;
    }
    @media (min-width: 768px) {
      width: calc(50% - 16px);
      margin: 0 8px 50px;
      &:nth-last-child(2):nth-child(odd) {
        margin-bottom: 0;
      }
    }
    @media (min-width: 992px) {
      width: calc(50% - 30px);
      margin-left: 15px;
      margin-right: 15px;
    }
    @media (min-width: 1700px) {
      width: calc(33.333% - 30px);
    }
  }
  .Blogposts_loadMoreWrapper {
    margin-top: 42px;
    display: flex;
    justify-content: center;
  }
`;


class Blogposts extends React.Component {
  constructor(props) {
    super(props);
    if (global.window !== undefined && global.document !== undefined) {
      const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      this.loadMoreNumber = viewportWidth < 992 ? 2 : 6;
    } else {
      this.loadMoreNumber = 6;
    }
    this.state = {
      show: this.loadMoreNumber,
    };
  }

  loadMore = () => {
    this.setState({
      show: this.state.show + this.loadMoreNumber,
    });
  }

  render() {
    const { show } = this.state;
    const { blogposts } = this.props;

    return (
      <section className={styles}>
        <div className="container">
          <div className="Blogposts_cardsWrapper">
            {
              blogposts.slice(0, show).map(post => (
                <BlogCard className="Blogposts_card" post={post} key={post._id} />
              ))
            }
          </div>
          {
            blogposts.length > show &&
            <div className="Blogposts_loadMoreWrapper">
              <button
                className="Btn Hollow"
                type="button"
                onClick={this.loadMore}
              >
                {`See the Next ${Math.min(this.loadMoreNumber, blogposts.length - show)} Posts`}
              </button>
            </div>
          }
        </div>
      </section>
    );
  }
}

Blogposts.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  blogposts: true,
})(Blogposts);



// WEBPACK FOOTER //
// ./src/pages/Blogposts/Blogposts.js